import React, { useState } from 'react';
import './BookingBar.css';
import TimePickerModal from './TimePickerModal';
import DatePickerModal from './DatePickerModal';
import GuestPickerModal from './GuestPickerModal';

const guestOptions = [1, 2, 3, 4, 5, 6, 7, 8];

const BookingBar = ({
  guestCount,
  onGuestChange,
  selectedDateIdx,
  onDateChange,
  selectedTime,
  onTimeChange,
  datesArr
}) => {
  const [showGuest, setShowGuest] = useState(false);
  const [showDate, setShowDate] = useState(false);
  const [showTime, setShowTime] = useState(false);
  
  const formatDate = (date, idx) => {
  const today = new Date();
    if (idx === 0) return `Today, ${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}`;
    return `${date.toLocaleString('en-US', { weekday: 'short' })}, ${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}`;
  };

  // Временные слоты для выбора
  const timeOptions = ['All Times'];
  for (let h = 13; h <= 22; h++) {
    for (let m = 0; m < 60; m += 30) {
      timeOptions.push(`${String(h).padStart(2, '0')}:${m === 0 ? '00' : '30'}`);
    }
  }

  return (
    <div className="booking-bar">
      <div className="booking-section" onClick={() => setShowGuest(true)}>
        <h4>Guests</h4>
        <div className="value">{guestCount}</div>
        <div className="dropdown-icon">▼</div>
      </div>
      <div className="booking-section" onClick={() => setShowTime(true)}>
        <h4>Time</h4>
        <div className="value">{selectedTime}</div>
        <div className="dropdown-icon">▼</div>
      </div>
      <div className="booking-section" onClick={() => setShowDate(true)}>
        <h4>Date</h4>
        <div className="value">{formatDate(datesArr[selectedDateIdx], selectedDateIdx)}</div>
        <div className="dropdown-icon">▼</div>
      </div>
      <GuestPickerModal open={showGuest} onClose={()=>setShowGuest(false)} onSelect={onGuestChange} selectedGuest={guestCount} />
      <TimePickerModal open={showTime} onClose={()=>setShowTime(false)} onSelect={onTimeChange} selectedTime={selectedTime} />
      <DatePickerModal open={showDate} onClose={()=>setShowDate(false)} onSelect={onDateChange} datesArr={datesArr} selectedDateIdx={selectedDateIdx} />
    </div>
  );
};

export default BookingBar; 